import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { TestDetailsDto } from 'api/Clients/Types/TestDetailsDto'
import { Loading } from 'components/Loading'
import { successToast, ToastContext } from 'components/Toast/Toast'
import { useApiClient } from 'utils/api/ApiClient'
import { ClientsApiClient } from 'utils/api/clientsApi'
import { useCallbackWithForceRefresh } from 'utils/api/useCallbackWithForceRefresh'
import { useFetchOne } from 'utils/api/useFetch'
import { appropriatenessTestDetailsUrl, links } from 'utils/featureToggles'

import { AppropriatenessTestDetailsForm } from './AppropriatenessTestDetailsForm'

const AppropriatenessTestDetailsPage = (): JSX.Element => {
  const clientsApiClient = useApiClient(ClientsApiClient)
  const setToast = useContext(ToastContext)
  const { id: testId } = useParams<{ id: string }>()

  const [crumbs, setCrumbs] = useState([
    { title: 'Appropriateness Test', link: links.complianceAppropriatenessTests.url },
  ])

  const { callback, forceRefresh } = useCallbackWithForceRefresh(() => {
    return testId ? clientsApiClient.getAppropriatenessTest(testId) : Promise.resolve(undefined)
  }, [])
  const { data, isLoading } = useFetchOne<TestDetailsDto>(callback)

  useEffect(() => {
    if (data?.name) {
      const [crumb1, crumb2] = [
        ...crumbs,
        {
          title: data.name,
          link: appropriatenessTestDetailsUrl(data.id),
        },
      ]
      setCrumbs([crumb1, crumb2])
    }
  }, [data?.name]) // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = async () => {
    setToast(successToast('Appropriateness Test updated successfully.'))
    forceRefresh()
  }

  return (
    <React.Fragment>
      <Breadcrumbs crumbs={crumbs} />
      <Loading isLoading={isLoading}>
        {data && <AppropriatenessTestDetailsForm data={data} onSubmit={onSubmit} />}
      </Loading>
    </React.Fragment>
  )
}

export default AppropriatenessTestDetailsPage
